const config = {
  ENV: 'production',
  BASE_API: 'https://ife-api.cinesend.com/api/'
}

export default config